import { MIN_USER_DEPOSIT_VALUE, ONE_MINUTE_MS } from 'src/constants';

import { useGetFullBalance } from 'react-easyrocket';
import { useGetUserBonusGames } from './useUserBonusGames';

export function useGameAvailabilityCheck() {
  const { userBonusGames } = useGetUserBonusGames();
  const { bonusAccountCasino, fullBalance } = useGetFullBalance({
    staleTime: ONE_MINUTE_MS,
    cacheTime: ONE_MINUTE_MS
  });

  return (gameId: number) => {
    if (
      bonusAccountCasino &&
      userBonusGames &&
      fullBalance &&
      bonusAccountCasino?.balance > 0 &&
      userBonusGames?.length > 0 &&
      !userBonusGames.find((game) => game.id === gameId) &&
      fullBalance?.balance[fullBalance.currency as keyof typeof fullBalance.balance] <
        MIN_USER_DEPOSIT_VALUE
    ) {
      return false;
    }
    return true;
  };
}
